import { Container, BitmapText } from '@pixi/react'
import { Assets } from 'pixi.js'
import { Image } from '@slot-nx/core'
import freeSpinLeftBoard from '../../asset/images/spinLeft_btn.png'
import { useGameStore } from '../domain/game/store/GameStore'

Assets.addBundle('freeSpinLeft', {
  freeSpinLeftBoard: { src: freeSpinLeftBoard, loadParser: 'loadTextures' },
})

export const FreeSpinLeft = () => {
  const width = 379
  const height = 187
  const isFreeGame = useGameStore(x => x.isFreeGame)
  const freeGameCount = useGameStore(x => x.freeGameCount)

  return (
    isFreeGame && (
      <Container
        name="freeSpinLeftBoard"
        x={345}
        y={1335}
        width={width}
        height={height}
      >
        <Image
          name="freeSpinLeftBoard"
          image="freeSpinLeftBoard"
          width={width}
          height={height}
          x={0}
          y={0}
        />
        <BitmapText
          name="totalWinPayout"
          text={`${freeGameCount}`}
          anchor={[0.5, 1]}
          style={{ fontName: 'FontW', fontSize: 32 }}
          y={125}
          x={255}
        />
      </Container>
    )

  )
}
